import React, { useContext } from "react";

import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import useDevice from "../../customHooks/useDevice";
import Map from "../Map/Map";
import MapLoader from "../MapLoader/MapLoader";

function MapStandalone(props) {
  const { height, mobileHeight,markerIcon  } = useContext(ComponentContext);
  const { isMobile } = useDevice();

  return (
    <div>
      <MapLoader>
        <Map {...props} height={isMobile ? mobileHeight : height} markerIconUrl={markerIcon?.url} />
      </MapLoader>
    </div>
  );
}

export default observer(MapStandalone);
